import { useEffect } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewFolderEdit = (visible: boolean) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useEffect(() => {
    if (!visible) return;
    logAnalyticsEvent({
      name: 'VIEW_FOLDER_EDIT',
      channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
    });
  }, [visible, logAnalyticsEvent]);
};
